<template>
    <Layout :header="{ text: '雲端e櫃檯', backBtn: { visible: true }, closeBtn: { visible: false, to: {} } }">
        <template #top>
            <div class=" bg-white border-b border-[#dadada]">
                <div class="tabs flex max-w-3xl mx-auto px-4">
                    <button @click="(e) => { goTab(i); }" class="tabs__btn py-3 w-1/2 relative"
                        :class="{ 'active': tabIndex === i }" v-for="(item, i) in ['預約申請', '查詢/取消預約資料']" :key="i">{{
                            item }}</button>
                </div>
            </div>
        </template>
        <!-- 預約申請 -->
        <div v-show="tabIndex === 0">
            <ul class="link-list">
                <li class="mb-3" v-for="(apl, idx) in pageData.aplList" :key="idx" @click="next(apl)">
                    <div
                        class="link-list__item__link w-full flex justify-between p-4 bg-white shadow-sm rounded-md font-bold fill-[#0093C1]">
                        <span>{{ apl.name }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width: 18px; height: 18px;">
                            <title>chevron-right</title>
                            <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                        </svg>
                    </div>
                </li>
            </ul>
            <Loading :is-loading="pageData.isLoading" />
        </div>
        <!-- 查詢取消預約資料 -->
        <div v-show="tabIndex === 1">

            <!-- 有資料 -->
            <template v-if="caseData">
                <CaseBox :caseBox="caseBox" v-for="(caseBox, i) in caseData" :key="i" />
            </template>
            <!-- 無資料 -->
            <div v-else class="text-center absolute top-1/4 left-1/2 -translate-x-1/2">

                <span class="inline-block">
                    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="6" y="6" width="42" height="47" fill="#C3C3C3" />
                        <circle cx="46" cy="46" r="15" fill="#C3C3C3" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M48 31.1322V53H32.7301C31.6255 50.9103 31 48.5282 31 46C31 37.7157 37.7157 31 46 31C46.6781 31 47.3457 31.045 48 31.1322Z"
                            fill="#686868" />
                        <rect x="12" y="16" width="27" height="4" fill="#F0F0F0" />
                        <rect x="12" y="27" width="18" height="4" fill="#F0F0F0" />
                        <rect x="51" y="58.5273" width="6" height="12" transform="rotate(-36 51 58.5273)"
                            fill="#C3C3C3" />
                    </svg>
                </span>

                <p class="text-nowrap">你目前沒有預約資料</p>

            </div>

        </div>
    </Layout>
</template>

<script setup>

import '@/assets/cloudCounter/css/style.css';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import { ref, inject } from 'vue';
import routeName from '@/router/constant.js';
import router from '@/router';
import { reactive } from 'vue';
import { initTransaction } from '@/apis/CloudECounter';
import { showReserverList } from '@/apis/CloudECounter';
// import aplCatlCode from '@/json/aplCatlCode';
// import serviceRoutes from '@/json/serviceRoutes';
import { useStore } from 'vuex';
import Loading from '@/components/Loading.vue';
import { startTransaction } from '@/apis/system';
import aplCatlCode from '@/json/aplCatlCode';
import serviceRoutes from '@/json/serviceRoutes';
import { openPopupCatchMessage } from '@/utils/vfmUtils';

const store = useStore();

const pageData = reactive({
    isLoading: true,
    checkOtp: false,
    aplList: [{
        aplCatl: aplCatlCode.LOAN,
        name: '保單借款',
        routeName: routeName.CLOUD_E_COUNTER_LOAN_NOTICE,
    }, {
        aplCatl: aplCatlCode.BENEIFCIARY,
        name: '受益人變更',
        routeName: routeName.CLOUD_E_COUNTER_POLICY,
    }, {
        aplCatl: aplCatlCode.APPLICANT_CHANGE,
        name: '要保人變更',
        routeName: routeName.CLOUD_E_COUNTER_POLICY,
    }, {
        aplCatl: '130',
        name: '要保人或被保險人姓名變更',
        routeName: routeName.CLOUD_E_COUNTER_POLICY,
    }],
});
const $vfm = inject('$vfm');
const next = (apl) => {
    pageData.isLoading = true;
    $vfm.show({
        component: 'DialogBase',
        params: {
            title: '變更需視訊確認才可完成',
            content: '提醒您！辦理【' + apl.name + '】須以視訊確認才能完成申請。',
            confirmButton: '我知道了',
            cancelButton: null,
            closeicon: false,
        },
        on: {
            confirm() {
                $vfm.hide('DialogBase');
                confirmNextStep(apl);
            },
            closed() {
                $vfm.hide('DialogBase');
                if (fn) {
                    fn();
                }
            },
        },
    });
};

const confirmNextStep = (apl) => {
    pageData.isLoading = true;
    initTransaction(apl.aplCatl).then((res) => {
        store.dispatch('services/setAplCatl', apl.aplCatl);
        store.dispatch('permissions/setTransactionId', res.data.transactionUniqueId);
        const index = serviceRoutes.findIndex(i => i.code === apl.aplCatl);
        const data = [{
            transactionItemName: apl.name,
            userChecked: true,
            transactionItemNo: apl.aplCatl,
            routeName: serviceRoutes[index].routeName,
        }];
        // for step route
        store.dispatch('services/setServices', data);
        // for 資料確認頁面
        store.dispatch('services/setTransactionItems', data);
        startTransaction().then(res => {
            router.push({ name: apl.routeName }).catch(err => {
                console.log(err);
            });
        });
        pageData.isLoading = false;
    }).catch((ex) => {
        pageData.isLoading = false;
        // if (ex?.data?.errorCode === 'InitTransaction.Check' || ex?.data?.errorCode === 'InitTransaction.All.Change') {
        //     openPopup(ex?.data?.errorMessage, () => {
        //         router.push({ name: routeName.CLOUD_E_COUNTER_HOME });
        //     });
        //     return;
        // }
        openPopupCatchMessage(ex);
    });
};

const setBoxData = (k, v) => {
    return {
        key: k,
        value: v,
    };
};

function box(title, flexclass, list) {
    this.title = title;
    this.flexclass = flexclass;
    this.list = list;
}
function boxItem(key, value) {
    this.key = key;
    this.value = value;
}
function Link(text, to) {
    this.text = text;
    this.to = to;
}
function CaseDataAi(value) {
    this.value = value;
}

const caseData = ref(null);
const tabIndex = ref(0);
const goTab = (index) => {
    tabIndex.value = (index >= 2 || !index) ? 0 : index;
    if (tabIndex.value == 1) {
        showReserver();
    }
};



const infoBoxVisble = ref(false);
const okHandel = () => {

};

const showReserver = () => {
    var caseDataAi = ([]);
    showReserverList().then((res) => {
        if (res.data != null && res.data.list.length > 0) {

            res.data.list.forEach(e => {
                console.log("e=");
                console.log(e);
                var boxList1 = new box('', 'justify-between', [new boxItem('申請日期', '111/06/05')
                    , new boxItem('申請項目', '要保人變更')
                    , new boxItem('保單號碼', '詳閱申請內容')
                    , new boxItem('受理案號', e.regiNo)
                    , new boxItem('視訊時間', '113/07/02<br>10:00-11:00')
                    , new boxItem('處理狀態', '待視訊確認中')
                ]);
                var link1 = new Link('查詢/取消申請內容', { name: 'cloudCounterDetailApplicant', query: { regiNo: e.regiNo } });
                caseDataAi.push({ boxList: [boxList1], link: link1 });
                // caseDataAi = new CaseDataAi([{boxList:[boxList1],link:link1}]);
            });
            console.log("caseDataAi.value");
            console.log(caseDataAi);

            //caseDataAi = new CaseDataAi([{boxList:[boxList1],link:link1}])
            caseData.value = caseDataAi;
        }


    }).catch((ex) => {
        console.log(ex);
    });

    // 串接取得預約資料清單
    /**
     * link name
     * 借款: cloudCounterDetailLoan
     * 要保人姓名變更: cloudCounterDetailName
     * 要保人變更: cloudCounterDetailApplicant
     * 受益人變更: cloudCounterDetailBeneficiary
     */


    // caseData.value.boxList.push();


    // caseData.value.boxList.push();





    // caseData.value = [
    //     {
    //         boxList: [
    //             {
    //                 title: '',
    //                 flexClass: 'justify-between', // 每列項目對齊左右兩側，若空白則預設垂直排列
    //                 list: [
    //                     { key: '申請日期', value: '113/06/15' },
    //                     { key: '申請項目', value: '要保人變更' },
    //                     { key: '保單號碼', value: '詳閱申請內容' },
    //                     { key: '受理案號', value: '114-WBP-0023902' },
    //                     { key: '視訊時間', value: '113/07/02<br>10:00-11:00' },
    //                     { key: '處理狀態', value: '待視訊確認中1' }
    //                 ]
    //             }
    //         ],
    //         link: {
    //             text: '查詢/取消申請內容',
    //             to: { name:'cloudCounterDetailApplicant' },
    //         }
    //     }, {
    //         boxList: [
    //             {
    //                 title: '',
    //                 flexClass: 'justify-between', // 每列項目對齊左右兩側，若空白則預設垂直排列
    //                 list: [
    //                     { key: '申請日期', value: '113/06/15' },
    //                     { key: '申請項目', value: '保單借款' },
    //                     { key: '保單號碼', value: '詳閱申請內容' },
    //                     { key: '受理案號', value: '114-sdd-0023902' },
    //                     { key: '視訊時間', value: '113/07/02<br>10:00-11:00' },
    //                     { key: '處理狀態', value: '待視訊確認中3' }
    //                 ]
    //             }
    //         ],
    //         link: {
    //             text: '查詢/取消申請內容',
    //             to: { name:'cloudCounterDetailLoan' },
    //         }
    //     }
    // ];

};


pageData.isLoading = false;

</script>

<style scoped>
.tabs__btn.active {
    font-weight: bold;
}

.tabs__btn.active::after {
    content: '';
    display: block;
    width: 100%;
    height: 4px;
    position: absolute;
    bottom: 0;
    border-radius: 6px;
    background: #0093C1;
}
</style>
